import {Container} from '@mantine/core'
import {createFileRoute} from '@tanstack/react-router'

import {RentalAssetsLayout} from '../../assets/rental-assets/rental-assets-layout'

export const Route = createFileRoute('/_app/rental-assets')({
    component: RentalAssetsRoute,
})

function RentalAssetsRoute() {
    return (
        <Container size="lg" py="xl">
            <RentalAssetsLayout />
        </Container>
    )
}
